import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const DraftOrderRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.draft_order_create === true ||
    permissions.draft_order_edit === true ||
    permissions.draft_order_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default DraftOrderRouteMiddleware;
